import React, { useState } from 'react';
import styles from './_style.module.scss';
import OptionsCommon from 'components/quote_builder_widget/form/options/OptionsCommon.jsx';

const OptionIntegerWithRange = ({ id, drawing, option, unit }) => {
  const formattedValue = (value) => value;

  const [isVisible, value, onChange, highlighted] = OptionsCommon({
    formattedValue,
    id,
    drawing,
    option,
    unit,
  });

  const defaultOptions = () => {
    if (option.possible_values.length > 0) {
      return option.possible_values;
    }
    return Array.from(
      { length: option.max_int_value - option.min_int_value + 1 },
      (_, i) => i + option.min_int_value
    );
  };

  const [options] = useState(defaultOptions());

  if (!isVisible) {
    return <input type="hidden" name={option.name} value={value} />;
  }

  return (
    <div className={styles.formGroup}>
      <label className={styles.label}>{option.presented_name}</label>
      <div className={styles.inputWrapper}>
        <select
          name={option.name}
          value={value}
          onChange={onChange}
          className={`${styles.input} ${styles.inputWithoutSuffix}`}
        >
          {options.map((i) => (
            <option key={i} value={i}>
              {i}
            </option>
          ))}
        </select>
      </div>
    </div>
  );
};

export default OptionIntegerWithRange;
